import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '@/_metronic/helpers'
import {
  Customer,
  CustomersQueryResponse,
  CustomerIndicators,
  CustomerSettings,
  ComputedBalance
} from './_models'

const CUSTOMER_URL = `/p2c/users`

export const getCustomers = (query: string): Promise<CustomersQueryResponse> => {
  return axios
    .get(`${CUSTOMER_URL}?${query}`)
    .then((d: AxiosResponse<CustomersQueryResponse>) => {
      return d.data
    })
}

export const getCustomer = (id: ID): Promise<Customer | undefined> => {
  return axios
    .get(`${CUSTOMER_URL}/${id}`)
    .then((response: AxiosResponse<Response<Customer>>) => response.data)
    .then((response: Response<Customer>) => response.data)
}

export const getComputedBalance = (id: ID): Promise<ComputedBalance | undefined> => {
  return axios
    .get(`${CUSTOMER_URL}/${id}/balance`)
    .then((response: AxiosResponse<Response<ComputedBalance>>) => response.data)
    .then((response: Response<ComputedBalance>) => response.data)
}

export const flushBalance = (id: ID): Promise<void> => {
  return axios
    .put(`${CUSTOMER_URL}/${id}/balance`)
    .then((response: AxiosResponse<Response<void>>) => response.data)
    .then(() => {})
}

export const getCustomerIndicators = (id: ID): Promise<CustomerIndicators | undefined> => {
  return axios
    .get(`${CUSTOMER_URL}/${id}/indicators`)
    .then((response: AxiosResponse<Response<CustomerIndicators>>) => response.data)
    .then((response: Response<CustomerIndicators>) => response.data)
}

export const updateSettings = (customerId: ID, settings: CustomerSettings): Promise<Customer | undefined> => {
  return axios
    .put(`${CUSTOMER_URL}/${customerId}/settings`, settings)
    .then((response: AxiosResponse<Response<Customer>>) => response.data)
    .then((response: Response<Customer>) => response.data)
}

export const setStatus = (customerId: ID, status: string, reason: string): Promise<Customer | undefined> => {
  return axios
    .put(`${CUSTOMER_URL}/${customerId}/status`, {status, reason})
    .then((response: AxiosResponse<Response<Customer>>) => response.data)
    .then((response: Response<Customer>) => response.data)
}

interface Impersonate {
  redirect: string;
}

export const impersonate = (customerId: ID): Promise<void> => {
  return axios
    .get(`${CUSTOMER_URL}/impersonate/${customerId}`)
    .then((response: AxiosResponse<Response<Impersonate>>) => response.data)
    .then((response: Response<Impersonate>) => {
      const redirectUrl = response.data?.redirect;
      window.open(redirectUrl, '_blank', 'noopener,noreferrer');
    })
};
